import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import {  Observable, throwError } from 'rxjs';
import { AdminTagsApproveParam, TagCloudNameList, adminSetting, adminValue, config, libSuggestion, libSuggestionStatus, newsAdd, newsParam, reviewData, reviewDataAdd } from '../models/walai';
import { catchError } from 'rxjs/operators';
import { ApiConfig, ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private _apiconfig: ApiConfig;
  private apiUrl = '';
  private token = '';

  // private baseUrl = '';
  //header = new HttpHeaders();

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {
    this._apiconfig =  this.configService.apiConfig;
    this.apiUrl = this._apiconfig.url;
    this.token = this._apiconfig.token;
    //this.header.append('authorization','');
    // this.header.append('Content-Type', 'application/json');
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      //authorization: ''
    }),
  };

  
  private handleError(err: HttpErrorResponse): Observable<never> {
    return throwError(() => err);
  }

  // public generalPageSettingSubject = new BehaviorSubject<adminSetting[]>([]);
  // updateGeneralPageSetting(settings: adminSetting[]): void {
  //   this.generalPageSettingSubject.next(settings);
  // }

  getGeneralPageSetting(): Observable<adminSetting[]> {
    return this.http.get<adminSetting[]>(`${this.apiUrl}/api/GeneralPageSetting`, this.httpOptions);
  }

  getLDAP(): Observable<adminSetting[]> {
    return this.http.get<adminSetting[]>(`${this.apiUrl}/api/getLDAP`, this.httpOptions);
  }

  PutGeneralPageSetting(parameterkey: string, val: adminValue) {
    return this.http.put<any>(`${this.apiUrl}/api/GeneralPageSetting/${parameterkey}`, val, this.httpOptions);
  }

  getAboutUSContactRule(type: string): Observable<string> {
    return this.http.get<string>(`${this.apiUrl}/api/AboutUSContactRule/${type}`, this.httpOptions);
  }

  PutAboutUSContactRule(type: string, val: adminValue) {
    return this.http.put<any>(`${this.apiUrl}/api/AboutUSContactRule/${type}`, val, this.httpOptions);
  }

  getLibrarianSuggest(): Observable<libSuggestion[]> {
    return this.http.get<libSuggestion[]>(`${this.apiUrl}/api/LibrarianSuggest`, this.httpOptions);
  }

  addLibrarianSuggest(bibid: string) {
    return this.http.post<libSuggestionStatus>(`${this.apiUrl}/api/LibrarianSuggest/${bibid}`, this.httpOptions);
  }

  deleteLibrarianSuggest(bibid: adminValue) {
    let body = bibid;

    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: body,
    };

    return this.http.delete<any>(`${this.apiUrl}/api/LibrarianSuggest`, httpOptions1);
  }

  newsList(val: newsParam): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/api/newsList`, val, this.httpOptions);
  }

  newsAdd(val: newsAdd): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/api/AddNews`, val, this.httpOptions);
  }

  newsUpdate(val: newsAdd): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/api/UpdateNews`, val, this.httpOptions);
  }

  public newsDelete(id: string): Observable<any> {
    return this.http.delete<any[]>(
      `${this.apiUrl}/api/news/${id}`,
      this.httpOptions
    );
  }

  public getNews(id: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.apiUrl}/api/news/${id}`,
      this.httpOptions
    );
  }

  // public uploadFile(file: FormData,id:string,type:string): Observable<any> {
  //   const headers = {
  //     headers: new HttpHeaders().set('accept', 'application/json'),
  //   };

  //   return this.http.post<any>(
  //     `${this.apiUrl}/api/UploadFiles/${type}/${id}`,
  //     file,
  //     headers
  //   );
  // }

  public uploadFile(file: FormData, id: string, type: string): Observable<any> {
    return this.http
      .post<any>(`${this.apiUrl}/api/UploadFiles/${type}/${id}`, file, {
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  addLibReview(val: reviewDataAdd): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/api/bookAddReview`, val, this.httpOptions);
  }

  updateLibReview(val: reviewDataAdd): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}/api/bookUpdateReview`,
      val,
      this.httpOptions
    );
  }

  public getReview(id: number): Observable<reviewData[]> {
    return this.http.get<reviewData[]>(
      `${this.apiUrl}/api/bookGetReviewByID/${id}`,
      this.httpOptions
    );
  }

  //Default search result layout 
  GetOpacConfigDefaultlayout(parameterkey: string): Observable<string> {
    return this.http.get<string>(`${this.apiUrl}/api/GetOpacConfigValue/${parameterkey}`, this.httpOptions);
  }

  GetOpacConfigValue(parameterkey: string): Observable<string> {
    return this.http.get<string>(`${this.apiUrl}/api/GetOpacConfigValue/${parameterkey}`, this.httpOptions);
  }

  getColorSetting(parameterkey: string): Observable<string> {
    return this.http.get<string>(`${this.apiUrl}/api/GetOpacConfigValue/${parameterkey}`, this.httpOptions);
  }

  public getColorSettingPipe(parameterkey: string): Observable<any> {
    return this.http
      .get<any>(
        `${this.apiUrl}/api/GetOpacConfigValue/${parameterkey}`,
        {
          observe: 'response',
        }
      )
      .pipe(catchError(this.handleError));
  }

  getLogoBanner(parameterkey: string): Observable<string> {
    return this.http.get<string>(`${this.apiUrl}/api/getLogoBanner/${parameterkey}`, this.httpOptions);
  }

  public getLogoBannerPipe(parameterkey: string): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/api/getLogoBanner/${parameterkey}`, {
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  PutColorSetting(inputconfig: config) {
    return this.http.put<any>(`${this.apiUrl}/api/StyleSetting`, inputconfig, this.httpOptions);
  }

  getFacetSetting(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/GetFacetDisplay`, this.httpOptions);
  }
  PutFacetSetting(CDID: string, display: number) {
    return this.http.put<any>(`${this.apiUrl}/api/updateFacetDisplay/${CDID}/${display}`, this.httpOptions);
  }

  public AddOPACImage(form: FormData): Observable<any> {
    return this.http
      .post<any>(`${this.apiUrl}/api/AddOPACImage`, form, {
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  DeleteOPACImage(id: string): Observable<string> {
    return this.http.delete<string>(`${this.apiUrl}/api/OPACImage/${id}`, this.httpOptions);
  }

  getViewOPAC(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/GetViewOPAC`, this.httpOptions);
  }

  getTopKeyword(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/GetTopKeyword`, this.httpOptions);
  }

  getTagCloud(): Observable<TagCloudNameList[]> {
    return this.http.get<TagCloudNameList[]>(`${this.apiUrl}/api/GetTag`, this.httpOptions);
  }

  TagsApprove(param: AdminTagsApproveParam): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/api/TagsApprove`, param, this.httpOptions);
  }

  async TagsApproveAwait(param: AdminTagsApproveParam) {
    const response = await this.http.put<any>( `${this.apiUrl}/api/TagsApprove`, param, this.httpOptions);
    return response;
  }

  updateTagsApproveStatus(val: boolean): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/api/updateTagsApproveStatus/${val}`, this.httpOptions);
  }
}
